"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMAND_REGEX = void 0;
exports.COMMAND_REGEX = /^\s*([^\s]+):(.*)/;
